export const isDevelopment = () => window?.location?.hostname === 'localhost'
